<template>
  <BaseSelect2
    :configs="configs"
    v-model="value"
    @input="filterColumns"
    ref="selector"
  >
    <optgroup
      v-for="(optGroup, optGroupName) in data"
      :key="optGroupName"
      :label="optGroupName"
      :data-color="optGroup.color"
    >
      <option
        v-for="option in optGroup.options"
        :key="option.metaId"
        :value="option.metaId"
      >
        {{option.metaName}}
      </option>
    </optgroup>
  </BaseSelect2>
</template>

<script>
export default {
  props: {
    data: {
      type: [Array, Object],
      required: true,
    },
    dtSettings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      configs: {
        theme: 'bootstrap',
        // width: '400px',
        multiple: true,
        placeholder: 'Filter cancer subtype',
        templateResult: this.formatColor,
      },
      value: [],
    };
  },
  created() {
    this.dtApi = new $.fn.dataTable.Api(this.dtSettings);
    this.bindEvents();
  },
  methods: {
    formatColor(item) {
      const { element } = item;
      if (typeof element !== 'undefined' && element.tagName.toLowerCase() === 'optgroup') {
        const { color } = element.dataset;
        const $flag = $('<span></span>').addClass('select-flag').css('background-color', color);
        return $('<div></div>').css('color', color).append($flag).append(item.text);
      }
      return item.text;
    },
    filterColumns(metaIds) {
      const { dtApi } = this;
      if (metaIds.length === 0) {
        dtApi
          .columns()
          .visible(true, false)
          .columns
          .adjust()
          .draw(false);
        return;
      }
      const selectors = metaIds.map(metaId => `[data-meta-id="${metaId}"]`);
      dtApi
        .columns('[data-meta-id]')
        .visible(false, false)
        .columns(selectors.join(','))
        .visible(true, false)
        .columns
        .adjust()
        .draw(false)
        .state.save();
    },
    checkState() {
      const state = this.dtApi.state.loaded();
      if (state) {
        const stateSelector = state.selector;
        if (stateSelector) {
          const { selected } = stateSelector;
          if (selected) {
            this.value = selected;
          }
        }
      }
    },
    saveState(data) {
      const data2 = data;
      if (typeof data2.selector === 'undefined') {
        data2.selector = {};
      }
      data2.selector.selected = this.value;
    },
    unbindEvents() {
      this.dtApi.off('stateSaveParams.dt');
    },
    bindEvents() {
      this.dtApi
        .one('init.dt', () => {
          this.checkState();
        })
        .on('stateSaveParams.dt', (e, settings, data) => {
          this.saveState(data);
        })
        .one('destroy.dt', () => {
          this.unbindEvents();
          // call 'this.$destroy()' will cause dataTables throw errors
          this.$off();
        });
    },
  },
};
</script>

<style>
  .select2-results__group {
    position: relative;
  }

  .select-flag {
    position: absolute;
    left: 0;
    top: 0;
    width: 5px;
    height: 100%;
  }
</style>
